export const NOT_PAYED = {
  value: "NOT_PAYED",
  key: "memberCoverages.inactivityReasons.notPaid",
};
export const PERMANENT_DEACTIVATION = {
  value: "PERMANENT_DEACTIVATION",
  key: "memberCoverages.inactivityReasons.withdrawnPermanentlyClean",
};
export const ANNUAL_DEACTIVATION = {
  value: "ANNUAL_DEACTIVATION",
  key: "memberCoverages.inactivityReasons.withdrawnYearlyClean",
};
export const SESSION_DEACTIVATION = {
  value: "SESSION_DEACTIVATION",
  key: "memberCoverages.inactivityReasons.withdrawnSessionallyClean",
};
export const DROPPED_OUT = {
  value: "DROPPED_OUT",
  key: "memberCoverages.inactivityReasons.droppedOutClean",
};
export const DEATH = {
  value: "DEATH",
  key: "memberCoverages.inactivityReasons.deathClean",
};
export const BOUGHT_BY_CLIENT_OUTSIDE_MAJOR = {
  value: "BOUGHT_BY_CLIENT_OUTSIDE_MAJOR",
  key: "memberCoverages.inactivityReasons.boughtByClientOutsideMajorClean",
};
export const BOUGHT_BY_MAJOR_CLIENT = {
  value: "BOUGHT_BY_MAJOR_CLIENT",
  key: "memberCoverages.inactivityReasons.boughtByMajorClientClean",
};
export const LEAVING_FOR_COMPETITOR = {
  value: "LEAVING_FOR_COMPETITOR",
  key: "memberCoverages.inactivityReasons.leavingForCompetitorClean",
};
export const NO_LONGER_OFFERS_GROUP_INSURANCE = {
  value: "NO_LONGER_OFFERS_GROUP_INSURANCE",
  key: "memberCoverages.inactivityReasons.noLongerOffersGroupInsuranceClean",
};
export const ELIGIBILITY_CRITERIA_TOO_SMALL = {
  value: "ELIGIBILITY_CRITERIA_TOO_SMALL",
  key: "memberCoverages.inactivityReasons.eligibilityCriteriaTooSmallClean",
};
export const BANKRUPTCY = {
  value: "BANKRUPTCY",
  key: "memberCoverages.inactivityReasons.bankruptcyClean",
};
export const OTHER = {
  value: "OTHER",
  key: "memberCoverages.inactivityReasons.otherClean",
};

let COMMON_REASONS = [
  NOT_PAYED,
  PERMANENT_DEACTIVATION,
  ANNUAL_DEACTIVATION,
  DROPPED_OUT,
  BANKRUPTCY,
  ELIGIBILITY_CRITERIA_TOO_SMALL,
  NO_LONGER_OFFERS_GROUP_INSURANCE,
  LEAVING_FOR_COMPETITOR,
  BOUGHT_BY_MAJOR_CLIENT,
  BOUGHT_BY_CLIENT_OUTSIDE_MAJOR,
  DEATH,
  OTHER,
];
export const ALL_INACTIVE_REASONS = [...COMMON_REASONS, SESSION_DEACTIVATION];

export default COMMON_REASONS;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/enums/memberCoverageInactivityReasons.js